<template>
  <div
    v-cloak
    class="sidebar-layout">
    <side-navigator v-show="!collapsed"/>
    <el-main
      :class="{ hidden: collapsed }"
      class="with-sidebar">
      <top-navigator/>
      <div class="inner-content">
        <slot/>
      </div>
    </el-main>
  </div>
</template>

<script>
import SideNavigator from '@/components/navigation/SideNavigator'
import TopNavigator from '@/components/navigation/TopNavigator'

export default {
  name: 'SidebarLayout',
  components: {
    SideNavigator,
    TopNavigator,
  },
  data() {
    return {
      collapsed: false,
    }
  },
  mounted() {
    // Temporary workaround to hide sidebar for contractors
    if (this.$store.getters['Auth/user'].roles.length === 1 &&
    (this.$store.getters['Auth/user'].roles.includes('Device Install Contractor') ||
    this.$store.getters['Auth/user'].roles.includes('Network Health Contractor'))) {
      this.collapsed = true
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/styles/mixins/resass.scss';

.el-main.with-sidebar {
  padding-left: 220px;
  margin-top: 40px;
}

.el-main.with-sidebar.hidden {
  padding-left: 30px;
}

.inner-content {
  padding-top: 20px;
  @include r(1280) {
    padding-left: 30px;
    padding-right: 30px;
    max-width: 1000px;
    margin: 0 auto;
  }
  @include r(1500) {
    padding-left: 80px;
    padding-right: 80px;
    max-width: 1200px;
    margin: 0 auto;
  }
}
.sidebar-layout {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/SidebarLayout.vue